"use client";

import React, { useState } from "react";
import { SwapperDrawer } from "./SwapperDrawer";
import { SwapperFooter } from "./SwapperFooter";
import { Menu } from "lucide-react";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex bg-white overflow-x-hidden">
      {/* Drawer Sidebar */}
      <SwapperDrawer
        isOpen={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
      />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col md:ml-64 overflow-x-hidden">
        {/* Mobile Header with Hamburger */}
        <div className="md:hidden sticky top-0 z-30 bg-swapper-light">
          <div className="flex items-center justify-between px-4 h-16">
            <button
              onClick={() => setIsSidebarOpen(true)}
              className="p-2 hover:bg-white rounded-xl transition-colors"
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6 text-swapper-secondary" />
            </button>

            <div className="flex items-center gap-3">
              <img
                src="/assets/logo.png"
                alt="Swapper"
                className="w-8 h-8 object-contain"
              />
            </div>
          </div>
        </div>

        {/* Content with Padding and Rounded Corners */}
        <main className="flex-1 p-2 md:p-4">
          <div className="bg-white overflow-hidden h-full ">{children}</div>
        </main>

        {/* Footer */}
        <div className="p-2 md:p-4 pt-0">
          <div className="bg-white rounded-2xl overflow-hidden">
            <SwapperFooter />
          </div>
        </div>
      </div>
    </div>
  );
};
